import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: "insert",

  siteNo: null,
  //   LAB_NAME: null,
  // LAB_SEQ: null,
  ykiho: null,
  INSPCT_MANAGER_NAME: null,
  SIDO: null,
  comment: null,

  updateFields: [],
};

export const clinicalSiteSlice = createSlice({
  name: "clinicalSite",
  initialState,
  reducers: {
    updateAction: (state, action) => {
      return {
        ...state,
        action: action.payload.action,
      };
    },

    updateSiteNo: (state, action) => {
      return {
        ...state,
        siteNo: action.payload.siteNo,
      };
    },

    updateLAB_NAME: (state, action) => {
      return {
        ...state,
        LAB_NAME: action.payload.LAB_NAME,
        updateFields: [...state.updateFields, "LAB_NAME"],
      };
    },

    updateLAB_SEQ: (state, action) => {
      return {
        ...state,
        LAB_SEQ: action.payload.LAB_SEQ,
        updateFields: [...state.updateFields, "LAB_SEQ"],
      };
    },

    updateYkiho: (state, action) => {
      return {
        ...state,
        ykiho: action.payload.ykiho,
        updateFields: [...state.updateFields, "ykiho"],
      };
    },

    updateLAB_INFO: (state, action) => {
      return {
        ...state,
        // LAB_SEQ: action.payload.LAB_SEQ,
        ykiho: action.payload.ykiho,
        SIDO: action.payload.SIDO,
        updateFields: [...state.updateFields, "LAB_SEQ"],
      };
    },

    updateINSPCT_MANAGER_NAME: (state, action) => {
      return {
        ...state,
        INSPCT_MANAGER_NAME: action.payload.INSPCT_MANAGER_NAME,
        updateFields: [...state.updateFields, "INSPCT_MANAGER_NAME"],
      };
    },

    updateSIDO: (state, action) => {
      return {
        ...state,
        SIDO: action.payload.SIDO,
        updateFields: [...state.updateFields, "SIDO"],
      };
    },

    updateComment: (state, action) => {
      return {
        ...state,
        comment: action.payload.comment,
        updateFields: [...state.updateFields, "comment"],
      };
    },

    init: (state, action) => {
      return {
        ...initialState,
      };
    },

    updateAll: (state, action) => {
      return {
        ...action.payload,
        updateFields: [],
      };
    },
  },
});

export const {
  updateAction,
  updateSiteNo,
  updateLAB_NAME,
  updateINSPCT_MANAGER_NAME,
  updateSIDO,
  updateComment,
  updateLAB_SEQ,
  updateYkiho,
  updateLAB_INFO,
  init,
  updateAll,
} = clinicalSiteSlice.actions;

export default clinicalSiteSlice.reducer;
